import comparisonAddToastComponent from "Components/comparisonAddToastComponent";

export default () => {
	return {
		el: "#add-comparison-toast",
		components:
		{
			"add-comparison": comparisonAddToastComponent
		}
	}
};